/** The Statistics filter row's custom date range and recurring-hours filter. */
export const translationStatistics_en_hours = {
  hoursFilterRecurring: "Filter recurring hours",
  hoursFilterTimezone: "Timezone",
  hoursFilterMondayFriday: "Monday–Friday",
  hoursFilterEveryDay: "Every day",
  hoursFilterWeekendHours: "Use different weekend hours",
  hoursFilterSaturdaySunday: "Saturday–Sunday",
  hoursFilterHowHoursApply: "How hours apply",
  hoursFilterHowHoursApplyBody:
    "Start is included; end is excluded. An earlier end wraps across midnight; equal times mean all day. Each calendar day uses its own window, including early-morning hours. Conversation statistics use conversation start; livechat follows its conversation; email usage uses completion time.",
  hoursFilterCommerceUnavailable:
    "Commerce and chat-open metrics are unavailable for this conversation-hours filter. Clear it to generate reports or export; scheduled reports keep their own scope.",
  hoursFilterAllDay: "All day",
  hoursFilterFrom: "From",
  hoursFilterUntil: "Until",
  statisticsDateRange: "Date range",
  statisticsPickDateRange: "Pick a date range",
};
